import React, { useEffect, useState,useContext } from "react";
import { Header } from "../components";
import { Select, initTE } from "tw-elements";
import {Chart} from "../components";
import axios from 'axios'
import axiosClient from "../axios-client";
import { userContext } from "../contexts/userContext";

const Dashboard = () => {
  const [selectedOption, setSelectedOption] = useState("Chairman");
  const [secondCardTitle, setSecondCardTitle] = useState("");
  const [positions,setPositons] = useState([])
  const [candidates,setCandidates] = useState([])
  const {user} = useContext(userContext)
  console.log(user)

  useEffect(() => {
    // const url = `http://localhost:5000/api/dashboard/${selectedOption}`
    const url = `https://mykura-nodejs-backend-fca8901da273.herokuapp.com/api/dashboard/${selectedOption}`
    axios.get(url)
    .then((res) => {
      console.log(res.data)
      if (res.data.data) setCandidates(res.data.data)
    })
    .catch((err) => console.log(err))
  }, [selectedOption]);

  useEffect(() => {
    
    axios.get('https://mykura-nodejs-backend-fca8901da273.herokuapp.com/api/dashboard')
    .then((res) => {
      console.log(res.data)
      if (res.data.titles) setPositons(res.data.titles)
    })
    .catch((err) => console.log(err))
  }, []);

  const handleOptionChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedOption(selectedValue);
  };

  return (
    <div className="h-screen mx-1 flex flex-col items-center">
      <Header pageView="Dashboard" />

      <div className="w-full max-w-[1200px] mx-auto flex sm:space-y-2 px-4 mt-10 space-y-4 flex-col items-center justify-center">
        <section className="px-2 text-white">
          <select
            className="w-full p-3 rounded outline-none text-white bg-blue mx-auto"
            value={selectedOption}
            onChange={handleOptionChange}
          >
            <option value="">Select an option</option>
            {positions.map((position,i) => (<option key = {i}>{position}</option>))}
          </select>
        </section>
      </div>

      <div>
        <div className="block rounded-lg bg-blue mt-8 p-6 shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] dark:bg-slate-700">
          <h5 className="mb-2 text-xl font-medium leading-tight text-neutral-800 dark:text-neutral-50">
            {secondCardTitle}
          </h5>

          <Chart candidates={candidates}/>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
